export default __webpack_public_path__ + "static/blog-post-3-169380191e5d976102405326ef90d8ab.png";